module.exports = __webpack_public_path__ + "static/media/require-mobile-device.388d41c3.svg";